import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
// import moment from "moment";

export default class QuickReportPromptController {
  constructor(options) {
    const $ctrl = this;
    basicController($ctrl);
    const {
      request = options.report,
      title
    } = options;
    console.info("options", options);
    $ctrl.request = {
      id: request.id,
      name: request.name,
      query: request.query,
      type: request.type,
      subType: request.subType,
      isActive: request.isActive,
      isDashboard: request.isDashboard,
      position: request.position,
      queryHtml: request.queryHtml,
      typeValues: [],
      tags: request.tags
    };

    if (request.type && request.type != undefined) {
      $ctrl.request.typeValues = [{
        type: request.type,
        total: 1
      }];
    }
    $ctrl.bus = new ServiceBus();
		$ctrl.bus.send('GetTemplates.json').then(function (response) {
			if (response.data) {
				$ctrl.templates = response.data.filter(t => t.labels.indexOf("report") > -1 || t.labels.indexOf("Report") > -1);
			}
      if ($ctrl.request.tags['Template'].length) $ctrl.templateId = $ctrl.request.tags['Template'][0];
			//if ($ctrl.templates.length === 1) $ctrl.request.tags['Template'] = $ctrl.templates[0].name;
		});

    $ctrl.dashboards = ["Executive","Sales Rep","Manager","Showroom","B2B","Customer"];
    $ctrl.roles = ["Sales Rep"];

    //$ctrl.request.typeValues = [request.type];

    //console.info("$ctrl.request", $ctrl.request);

    $ctrl.action = request.id ? "Update" : "Create";
    $ctrl.bus = new ServiceBus();
    $ctrl.title = title || `${$ctrl.action} Quick Report...`;
  }

  $onInit() {
    const $ctrl = this;
  }

  addType(search) {
      let $ctrl = this;
      var type = {
        type: search,
        total: 1,
      };
    return type;
  }

  parseQuery(report) {
    let $ctrl = this;
    var sql = [{ Sql: report.query }];
    $ctrl.bus
      .send(`ParseSQL.json`, sql[0])
      .then(function (response) {
        //console.info("response", response);
        $ctrl.request.queryHtml = response.data.htmlFormatter;
      });
  }
  submit() {
    const $ctrl = this;
    //console.info("$ctrl.request.type", $ctrl.request.typeValues);
    if ($ctrl.request.typeValues[0].type != undefined) {
      $ctrl.request.type = $ctrl.request.typeValues[0].type;
    } else {
      $ctrl.request.type = $ctrl.request.typeValues[0];
    }
    if ($ctrl.templateId) $ctrl.request.tags['Template'] = $ctrl.templateId;
    
    //console.info("$ctrl.request", $ctrl.request, $ctrl.action);
    $ctrl.bus
      .send(`${$ctrl.action}QuickReport.json`, $ctrl.request)
      .then(function(response) {
        $ctrl.$emit("quickReportSaved", $ctrl);
        $ctrl.$emit("refresh-quick-report", response);
        $ctrl.$close(response.data);
      });
  }

  delete() {
    const $ctrl = this;
    $ctrl.request.type = $ctrl.request.type[0].type;
    $ctrl.$close($ctrl.request);
    
    //return modals
    //  .confirm("Are you sure?", "Delete Quick Report")
    //  .result.then(function() {
    //    $ctrl.bus
    //      .send("DeleteQuickReport.json", $ctrl.request)
    //      .then(function(response) {
    //        $ctrl.$emit("quickReportDeleted", $ctrl);
    //        $ctrl.$emit("refresh-quick-report", response);
    //      });
    //  });
  }

  dismiss() {
    const $ctrl = this;
    //$ctrl.$emit('listSaved', $ctrl);
    $ctrl.$dismiss();
  }
}
